// extracted by mini-css-extract-plugin
export default {"techstackPage":"Techstack_techstackPage__lJGse","cards":"Techstack_cards__Z5vPW","techstackContainer":"Techstack_techstackContainer__oWYS3"};